import request from '@/utils/request'
// 题库类型 
export function systemList(params) {
    return request({
      url: 'system/dict/data/list',
      method:'get',
      params
    })
}
//考试列表
export function mockexamList(params) {
  return request({
    url: 'business/exam/api/exam/exam/online-paging',
    method:'get',
    params
  })
}

//1.创建试卷 
export function papercreate(data) {
  return request({
    url: 'business/exam/api/paper/paper/create-paper',
    method:'post',
    data
  })
}
/**
 * 2.试卷详情
 * @param data
 */
export function paperDetail(data) {
  return request({
    url: 'business/exam/api/paper/paper/paper-detail',
    method:'post',
    data
  })
}
//3.查询试题内容
export function quDetail(data) {
  return request({
    url: 'business/exam/api/paper/paper/qu-detail',
    method:'post',
    data
  })
}
//4.题目做题提交
export function fillAnswer(data) {
  return request({
    url: 'business/exam/api/paper/paper/fill-answer',
    method:'post',
    data
  })
}
//5.交卷
export function handExam(data) {
  return request({
    url: 'business/exam/api/paper/paper/hand-exam',
    method:'post',
    data
  })
}
//6.查询结果
export function paperResult(data) {
  return request({
    url: 'business/exam/api/paper/paper/paper-result',
    method:'post',
    data
  })
}
//我的考试查询列表
export function myexamList(params) {
  return request({
    url: 'business/exam/api/user/exam/my-paging',
    method:'get',
    params
  })
}